<template>
  <img id="myImage" src="./assets/clone.png" @click="loadImage" v-if="show_otp_image" />
  <div id="mySidenav" class="sidenav">
    <router-link to="/"><img alt="Home" title="Version 2024-09.1" src="./assets/dashboard.svg"
        style="width: 30px; height: 30px" /></router-link>
    <span v-if="isDispo">|</span>
    <router-link v-if="isDispo" to="/mybookings"><img alt="Bookings" title="Buchungen | Bookings"
        src="./assets/bookings.svg" style="width: 30px; height: 30px" /></router-link>
    <span v-if="isDispo">|</span>
    <router-link v-if="isDispo" to="/myoverview"><img alt="Bookings" title="Kalendar" src="./assets/day.svg"
        style="width: 30px; height: 30px" /></router-link>
    <span v-if="isDispoAdmin">|</span>
    <router-link v-if="isDispoAdmin" to="/myusers"><img title="Benutzer | Users" src="./assets/users.svg"
        style="width: 30px; height: 30px" /></router-link>
    <span v-if="isAdmin">|</span>
    <router-link v-if="isAdmin" to="/myadresses"><img title="Adressen | Adresses" src="./assets/address.svg"
        style="width: 30px; height: 30px" /></router-link>
    <span v-if="currUser">|</span>
    <router-link to="/about">About</router-link>
    <span v-if="isAdmin">|</span>
    <router-link v-if="isAdmin" to="/mycompanies"><img title="Firmen | Companies" src="./assets/company.svg"
        style="width: 30px; height: 30px" /></router-link>
    <span v-if="isAdmin">|</span>
    <router-link v-if="isAdmin" to="/mycargroups"><img title="Fahrzeuggruppen | Car groups" src="./assets/cargroups.svg"
        style="width: 30px; height: 30px" /></router-link>
    <img title="Kunde" src="./assets/system_mb.png" style="width: 50px; height: 50px; margin-top: 10px" />
  </div>
  <div class="rview">
    <router-view />
    <div class="info_normal" v-if="cks_mb_berlin_home_meta_edit">
      <br />
      <span class="act_button" v-on:click="metaup_date">Speichern</span>&nbsp;&nbsp;
      <span class="cancel_button" v-on:click="this.$router.go()">Abbruch</span>
      <br /><br /><br />
      <textarea style="text-align: center" rows="10" cols="25" v-model="cks_mb_berlin_home_meta.txt1"></textarea>
      <br />
    </div>
    <div class="info_normal" v-if="currUser">
      <div style="
          max-width: 250px;
          border-radius: 10px;
          border: 1.5px solid rgb(245, 216, 179);
          padding: 5px;
          box-shadow: 2px 2px 3px rgb(245, 216, 179);
          background-color: darkslategrey;
        " v-on:click="
          cks_mb_berlin_home_meta && isAdmin
            ? (cks_mb_berlin_home_meta_edit = true)
            : (cks_mb_berlin_home_meta_edit = false)
          ">
        {{
          cks_mb_berlin_home_meta && cks_mb_berlin_home_meta.txt1
            ? cks_mb_berlin_home_meta.txt1
            : "--"
        }}
      </div>
    </div>
  </div>
  <div class="sysInfo2" id="mainInfo"></div>
</template>

<script>
export default {
  name: "App",
  mounted: function () {
    this.loadMetaApp();
    this.myTimer = setInterval(this.doUping, 60000);
  },
  data() {
    return {
      currUser: "",
      isOnline: "No",
      core_url: this.getContext(),
      cks_car_group: "",
      cks_car_type: "",
      cks_adresses: "",
      cks_companies: "",
      cks_costs: "",
      cks_order_type: "",
      cks_zone: "",
      cks_fahrer: "",
      cks_all_users: "",
      //global data
      cks_mb_berlin_home_meta: "",
      cks_mb_berlin_home_meta_edit: false,
      show_otp_image: false,
      myTimer: "",
      myTimerCounter: 0,
    };
  },
  computed: {
    getUserNameID: function () {
      if (this.currUser) {
        return (
          this.currUser.SesUserObjectName +
          " (" +
          this.currUser.SesUserObjectToken +
          ")"
        );
      }
      return ">> USER NOT FOUND <<<";
    },
    isAdmin: function () {
      return this.currUser &&
        this.currUser.AppUserSESSION_USER_ROLES &&
        this.currUser.AppUserSESSION_USER_ROLES.cksadmin
        ? true
        : false;
    },
    isDispoAdmin: function () {
      if (this.isAdmin) return true;
      return this.currUser &&
        this.currUser.AppUserSESSION_USER_ROLES &&
        this.currUser.AppUserSESSION_USER_ROLES.cksdispoadmin
        ? true
        : false;
    },
    isDispo: function () {
      if (this.isDispoAdmin) return true;
      return this.currUser &&
        this.currUser.AppUserSESSION_USER_ROLES &&
        this.currUser.AppUserSESSION_USER_ROLES.cksdispo
        ? true
        : false;
    },
  },
  methods: {
    getContext() {
      var url = window.location.href;
      if (url.includes(":3000")) return "http://localhost:8080/carforce/core";
      // AIM on server "/carforce/core"
      return "/carforce/core";
      /*--
      var aUrl = url.split("/");
      if (aUrl.length > 2) return "/" + aUrl[3] + "/core";
      return url;
      */
    },
    getUserName(userID) {
      for (const item in this.cks_all_users) {
        if (parseInt(item.idusers) == parseInt(userID)) {
          return item.usr_email;
        }
      }
      return "--";
    },
    setOnline() {
      console.log("Set Online");
      this.isOnline = "Yes";
    },
    setUser(user) {
      this.currUser = user;
    },
    loadMeta() {
      //LOAD all meta data after LOGON
      if (window.localStorage.getItem("carforce_rqtoken")) {
        if (!this.cks_car_group) {
          this.loadCarGroup( false);
        }
        if (!this.cks_car_type) {
          this.loadcks_car_type( false);
        }
        if (!this.cks_adresses) {
          this.loadcks_adresses( false);
        }
        if (!this.cks_companies) {
          this.loadcks_companies( false);
        }
        if (!this.cks_costs) {
          this.loadcks_costs( false);
        }
        if (!this.cks_order_type) {
          this.loadcks_order_type( false);
        }
        if (!this.cks_zone) {
          this.loadcks_zone( false);
        }
        if (!this.cks_fahrer) {
          this.loadcks_fahrer( false);
        }
        //loadcks_all_users
        if (!this.cks_all_users) {
          this.loadcks_all_users( false);
        }
      }
    },
    loadCarGroup(token, doreload) {
      if (!this.cks_car_group || doreload) {
        console.log("loadCarGroup - start");
        this.statusMSG = "";
        var comp = this;

        var d = new Date();
        var n = d.getTime();

        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=jsq&jsc=cks_car_group";
        var url = myAppDataURL + "&z=" + n;
        console.log(url, "Try data refresh (loadCarGroup)... ");

        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            console.log("loadCarGroup - done");
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                console.log("ERROR: ", theResult.msg);
              } else {
                //Fill List
                comp.cks_car_group = theResult;
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);
        xmlhttp.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("carforce_rqtoken")
        );
        xmlhttp.send();
      } else {
        console.log("Info: CarGroup already loaded");
      }
    },
    loadcks_car_type( doreload) {
      if (!this.cks_car_type || doreload) {
        this.statusMSG = "";
        var comp = this;

        var d = new Date();
        var n = d.getTime();

        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=jsq&jsc=cks_car_type";
        var url = myAppDataURL + "&z=" + n;
        console.log("Try data refresh (cks_car_type)... ");

        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                console.log("ERROR: ", theResult.msg);
              } else {
                //Fill List
                comp.cks_car_type = theResult;
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);

        xmlhttp.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("carforce_rqtoken")
        );
        xmlhttp.send();
      } else {
        console.log("Info: cks_car_type already loaded");
      }
    },
    loadcks_all_users( doreload) {
      if (!this.cks_all_users || doreload) {
        this.statusMSG = "";
        var comp = this;

        var d = new Date();
        var n = d.getTime();

        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=jsq&jsc=cks_all_users";
        var url = myAppDataURL + "&z=" + n;
        console.log("Try data refresh (cks_all_users)... ");

        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                console.log("ERROR: ", theResult.msg);
              } else {
                //Fill List
                comp.cks_all_users = theResult;
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);

        xmlhttp.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("carforce_rqtoken")
        );
        xmlhttp.send();
      } else {
        console.log("Info: cks_all_users already loaded");
      }
    },
    loadcks_adresses( doreload) {
      if (!this.cks_adresses || doreload) {
        this.statusMSG = "";
        var comp = this;

        var d = new Date();
        var n = d.getTime();

        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=jsq&jsc=cks_adresses";
        var url = myAppDataURL + "&z=" + n;
        console.log("Try data refresh (cks_adresses)... ");

        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                console.log("ERROR: ", theResult.msg);
              } else {
                //Fill List
                comp.cks_adresses = theResult;
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);

        xmlhttp.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("carforce_rqtoken")
        );
        xmlhttp.send();
      } else {
        console.log("Info: cks_adresses already loaded");
      }
    },
    loadcks_companies( doreload) {
      if (!this.cks_companies || doreload) {
        this.statusMSG = "";
        var comp = this;

        var d = new Date();
        var n = d.getTime();

        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=jsq&jsc=cks_companies";
        var url = myAppDataURL + "&z=" + n;
        console.log("Try data refresh (cks_companies)... ");

        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                console.log("ERROR: ", theResult.msg);
              } else {
                //Fill List
                comp.cks_companies = theResult;
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);

        xmlhttp.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("carforce_rqtoken")
        );
        xmlhttp.send();
      } else {
        console.log("Info: cks_companies already loaded");
      }
    },
    loadcks_costs( doreload) {
      if (!this.cks_costs || doreload) {
        this.statusMSG = "";
        var comp = this;

        var d = new Date();
        var n = d.getTime();

        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=jsq&jsc=cks_costs";
        var url = myAppDataURL + "&z=" + n;
        console.log("Try data refresh (cks_costs)... ");

        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                console.log("ERROR: ", theResult.msg);
              } else {
                //Fill List
                comp.cks_costs = theResult;
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);

        xmlhttp.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("carforce_rqtoken")
        );
        xmlhttp.send();
      } else {
        console.log("Info: cks_costs already loaded");
      }
    },
    loadcks_order_type( doreload) {
      if (!this.cks_order_type || doreload) {
        this.statusMSG = "";
        var comp = this;

        var d = new Date();
        var n = d.getTime();

        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=jsq&jsc=cks_order_type";
        var url = myAppDataURL + "&z=" + n;
        console.log("Try data refresh (cks_order_type)... ");

        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                console.log("ERROR: ", theResult.msg);
              } else {
                //Fill List
                comp.cks_order_type = theResult;
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);

        xmlhttp.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("carforce_rqtoken")
        );
        xmlhttp.send();
      } else {
        console.log("Info: cks_order_type already loaded");
      }
    },
    loadcks_zone( doreload) {
      if (!this.cks_zone || doreload) {
        this.statusMSG = "";
        var comp = this;

        var d = new Date();
        var n = d.getTime();

        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=jsq&jsc=cks_zone";
        var url = myAppDataURL + "&z=" + n;
        console.log("Try data refresh (cks_zone)... ");

        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                console.log("ERROR: ", theResult.msg);
              } else {
                //Fill List
                comp.cks_zone = theResult;
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);

        xmlhttp.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("carforce_rqtoken")
        );
        xmlhttp.send();
      } else {
        console.log("Info: cks_zone already loaded");
      }
    }, //cks_fahrer
    loadcks_fahrer( doreload) {
      if (!this.cks_fahrer || doreload) {
        this.statusMSG = "";
        var comp = this;

        var d = new Date();
        var n = d.getTime();

        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=jsq&jsc=cks_fahrer";
        var url = myAppDataURL + "&z=" + n;
        console.log("Try data refresh (cks_fahrer)... ");

        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.error && theResult.error == 1) {
                console.log("ERROR: ", theResult.msg);
              } else {
                //Fill List
                comp.cks_fahrer = theResult;
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);

        xmlhttp.setRequestHeader(
          "Authorization",
          window.localStorage.getItem("carforce_rqtoken")
        );
        xmlhttp.send();
      } else {
        console.log("Info: cks_fahrer already loaded");
      }
    }, //cksuping
    doUping() {
      var rTok = window.localStorage.getItem("carforce_rqtoken");
      this.myTimerCounter++;
      if (this.myTimerCounter > 10) {
        console.log("UP done for than 10 Minutes");
        this.myTimerCounter = 0;
      }
      if (rTok) {
        var comp = this;
        var d = new Date();
        var n = d.getTime();
        var xmlhttp = new XMLHttpRequest();
        var myAppDataURL = this.core_url + "?action=uping";
        var url = myAppDataURL + "&z=" + n;
        xmlhttp.onerror = function (e) {
          console.log(e);
          document.getElementById("mainInfo").innerHTML =
            "Server may offline - please reload page after a few minutes ...";
        };

        xmlhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            if (this.responseText != null) {
              var theResult = JSON.parse(this.responseText);
              if (theResult && theResult.result && theResult.result == "NOK") {
                console.log("Logging off ... by timeout");
                window.localStorage.removeItem("carforce_rqtoken");
                comp.currUser = "";
                comp.$router.push('/');
              }
            }
          } else if (this.readyState == 4 && this.status != 200) {
            comp.statusMSG = "Server not responding. Status: " + this.status;
          }
        };
        xmlhttp.open("GET", url, true);
        xmlhttp.setRequestHeader("Authorization", rTok);
        xmlhttp.send();
      }
    }, //load cks_mb_berlin_home_meta
    loadMetaApp() {
      //var token = window.localStorage.getItem("carforce_rqtoken");
      this.statusMSG = "";
      var comp = this;

      var d = new Date();
      var n = d.getTime();

      var xmlhttp = new XMLHttpRequest();
      var myAppDataURL =
        this.core_url + "?action=qjason&jsc=cks_mb_berlin_home_meta";
      var url = myAppDataURL + "&z=" + n;
      console.log("Try data get meta data ... ");

      xmlhttp.onerror = function (e) {
        console.log(e);
        document.getElementById("mainInfo").innerHTML =
          "Server may offline - please reload page after a few minutes ...";
      };

      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          if (this.responseText != null) {
            var theResult = JSON.parse(this.responseText);
            if (theResult && theResult.error && theResult.error == 1) {
              console.log("ERROR: ", theResult.msg);
            } else if (theResult && theResult[0]) {
              console.log("Meta data found and set.");
              comp.cks_mb_berlin_home_meta = theResult[0];
            } else {
              comp.cks_mb_berlin_home_meta = "";
            }
          }
        } else if (this.readyState == 4 && this.status != 200) {
          comp.statusMSG = "Server not responding. Status: " + this.status;
        }
      };
      xmlhttp.open("GET", url, true);

      xmlhttp.send();
    },
    metaup_date() {
      //SAVE/up_date
      var myComponent = this;
      var sSQL = "cks_mb_berlin_home_meta_up_date";
      var d = new Date();
      var n = d.getTime();
      var xmlhttp = new XMLHttpRequest();
      var jSonContent = {};
      var myUser = this.currUser
        ? this.currUser.SesUserObjectName +
        " (" +
        this.currUser.SesUserObjectToken +
        ")"
        : "UnKown";
      /*cks_ins_ert_up_date_meta_fahrer//*/
      jSonContent["1_String"] = this.cks_mb_berlin_home_meta.txt1;
      jSonContent["2_String"] = myUser;

      var myAppDataURL =
        this.$root.core_url + "?action=foisup&jsc=" + sSQL + "&isjson=1";
      var url = myAppDataURL + "&z=" + n;
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          console.log(this.responseText);
          myComponent.cks_mb_berlin_home_meta_edit = false;
        } else if (this.readyState == 4 && this.status != 200) {
          alert("Error loadWfItems request:" + this.status);
        }
      };
      xmlhttp.open("POST", url, true);
      xmlhttp.setRequestHeader(
        "Content-Type",
        "application/json;charset=UTF-8"
      );

      xmlhttp.setRequestHeader(
        "Authorization",
        window.localStorage.getItem("carforce_rqtoken")
      );
      xmlhttp.send(JSON.stringify(jSonContent));
    },
    loadImage() {
      //SAVE/up_date
      var d = new Date();
      var n = d.getTime();
      var xmlhttp = new XMLHttpRequest();

      var myAppDataURL = this.$root.core_url + "?action=topt";
      var url = myAppDataURL + "&z=" + n;
      xmlhttp.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          var uInt8Array = new Uint8Array(this.response);
          var i = uInt8Array.length;
          var binaryString = new Array(i);
          while (i--) {
            binaryString[i] = String.fromCharCode(uInt8Array[i]);
          }
          var data = binaryString.join("");

          var base64 = window.btoa(data);

          document.getElementById("myImage").src =
            "data:image/png;base64," + base64;
        } else if (this.readyState == 4 && this.status != 200) {
          alert("Error loadWfItems request:" + this.status);
        }
      };
      xmlhttp.open("GET", url, true);
      xmlhttp.responseType = "arraybuffer";

      xmlhttp.setRequestHeader(
        "Authorization",
        window.localStorage.getItem("carforce_rqtoken")
      );
      xmlhttp.send();
    },
  },
};
</script>

<style>
@import "./styles.css";
</style>
